module.exports = __webpack_public_path__ + "static/media/menuHeadset.1e2e0f00.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuHeadset.svg
// module id = 471
// module chunks = 0